import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=28d26f20&scoped=true"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=28d26f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d26f20",
  null
  
)

export default component.exports